<template>
  <article class="example-page">
    <h1>Invite Client Modal</h1>
    <button type="button" @click="toggleModal">Open Model</button>
    <client-invite-modal :displayed="modalDisplayed" @close="toggleModal" />
  </article>
</template>

<script>
import store from '@/store';
import { clientInviteModal } from '@/components/advisor';

export default {
  components: { clientInviteModal },
  data() {
    return {
      modalDisplayed: false,
    };
  },
  methods: {
    toggleModal() {
      this.modalDisplayed = !this.modalDisplayed;
    },
  },
  async beforeRouteEnter(to, from, next) {
    return Promise.all([
      store.dispatch('fetchAccount'),
    ])
      .then(next);
  },
};
</script>
